"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Event = void 0;
class FoquzEvent {
    constructor() {
        this.callbacks = [];
    }
    static { this.events = {}; }
    static add(eventName) {
        if (!FoquzEvent.events[eventName]) {
            let event = new FoquzEvent();
            FoquzEvent.events[eventName] = event;
        }
    }
    static get(eventName) {
        FoquzEvent.add(eventName);
        return FoquzEvent.events[eventName];
    }
    on(cb) {
        if (typeof cb == "function")
            this.callbacks.push(cb);
    }
    once(cb) {
        let _cb = (...params) => {
            cb(...params);
            this.off(_cb);
        };
        this.on(_cb);
    }
    off(cb) {
        let index = this.callbacks.indexOf(cb);
        this.callbacks.splice(index, 1);
    }
    emit(...params) {
        [...this.callbacks].forEach((cb) => cb(...params));
    }
}
window.FoquzEvent = window.FoquzEvent || FoquzEvent;
const Event = () => window.FoquzEvent;
exports.Event = Event;
